<cui-logged-layout [freeContentStyle]="freeContentStyle" noTitlebar="noTitlebar">
    <cui-layout-header >
        <base-navbar [enableMenu]="false" [showNotificaciones]="false"></base-navbar>
    </cui-layout-header>
    <cui-layout-footer>
        <footer-component></footer-component>
        <popup-cookies></popup-cookies>
        <typeform-widgets-view></typeform-widgets-view>
    </cui-layout-footer>
</cui-logged-layout>